<template>
  <div class="p-5">
    <h3 class="uppercase text-2xl">MÉTODO DE PAGO</h3>
    <div class="separator_form"></div>
    <div v-html="tagImage"></div>
    <div class="step">
      <PagoLoader v-show="loading" />
      <div v-show="!loading">
        <p class="font-semibold text-18 mb-5 sm:text-center xs:text-center">
          Elige tu Método de Pago
        </p>

        <PaymentMethodPaypal 
          v-model="paymentMethod" 
          :on-submit="onSubmit" 
        />

        <PaymentMethodCard 
          v-model="paymentMethod" 
          :information="information" 
          :url="url" 
        />

        <PaymentMethodEfectivo 
          v-model="paymentMethod" 
          :barcode="barcode" 
          :on-submit="onSubmit" 
        />

        <PaymentMethodTelmex 
          v-model="paymentMethod" 
          :on-submit="onSubmit" 
        />
      </div>

   
      <transition name="fade">
        <ModalPaymentEfectivo
          v-if="isSuccessPaymentEffectivo"
          :barcode="barcode"
          :barCodeReference="barCodeReference"
          @onClose="onCloseModalEfectivo"
        />
      </transition>
    </div>
  </div>
</template>

<script setup>
import { mapState, mapGetters } from 'vuex';
import { computed } from 'vue';
import PagoLoader from '@/components/loaders/Pago.vue';
import PaymentMethodPaypal from '@/components/checkout/pago/components/PaymentMethodPaypal.vue';
import PaymentMethodCard from '@/components/checkout/pago/components/PaymentMethodCard.vue';
import PaymentMethodEfectivo from '@/components/checkout/pago/components/PaymentMethodEfectivo.vue';
import PaymentMethodTelmex from '@/components/checkout/pago/components/PaymentMethodTelmex.vue';
import ModalNotificationInvalidPostalCode from '@/components/modals/ModalNotificationInvalidPostalCode.vue';
import ModalPaymentEfectivo from '@/components/modals/ModalPaymentEfectivo.vue';
import { usePaymentMethod } from '@/components/checkout/pago/composables/usePaymentMethod';
import { useStore } from 'vuex';

const store = useStore();

const error = computed(() => store.getters.getError);
const loading = computed(() => store.state.Subscription.loading);
const information = computed(() => store.state.Products.information);
const barcode = computed(() => store.state.Subscription.barcode);

const {
  paymentMethod,
  isSuccessPaymentEffectivo,
  barCodeReference,
  tagImage,
  url,
  onSubmit,
  onCloseModalEfectivo,
  onCloseSubscriptionError
} = usePaymentMethod();
</script>

<style scoped>
h3,
.separator_form {
  max-width: 440px;
}

input[type="radio"] {
  @apply relative;
  width: 20px;
  height: 20px;
  cursor: pointer !important;
}

input[type="radio"]:checked:after {
  @apply left-0 top-0 bg-black rounded-full relative visible border-white border-solid inline-block border-2;
  width: 20px;
  height: 20px;
  content: "";
}
</style>
